import { Boxes, GitBranch, Check } from "lucide-react";

const LANES = [
    { lane: "Discovery", items: [{ t: "Problem framing", done: true }, { t: "Success metrics", done: true }] },
    { lane: "Build", items: [{ t: "AI copilot · API", done: true }, { t: "Dashboard UI", active: true }] },
    { lane: "Ship", items: [{ t: "Eval harness", active: true }, { t: "GA rollout", done: false }] },
];

/**
 * Reusable "Product Engineering" delivery-board mockup.
 */
export default function EngineeringSprintPanel({ className = "" }) {
    return (
        <div
            className={`rounded-2xl bg-white border border-[#303030]/10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.55)] overflow-hidden ${className}`}
            data-testid="mockup-engineering-sprint"
            aria-hidden="true"
        >
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#303030]/8 bg-[#FAFAF8]">
                <div className="flex items-center gap-2">
                    <span className="w-6 h-6 grid place-items-center rounded-md bg-[#FF4040]/12 text-[#FF4040]">
                        <Boxes className="w-3.5 h-3.5" />
                    </span>
                    <span className="text-[12px] font-semibold text-[#303030]">Delivery board · Sprint 3</span>
                </div>
                <span className="inline-flex items-center gap-1 font-mono text-[10px] text-[#303030]/55">
                    <GitBranch className="w-3 h-3" /> main · CI green
                </span>
            </div>

            <div className="grid grid-cols-3 gap-2 p-3">
                {LANES.map((col, ci) => (
                    <div key={col.lane}>
                        <p className="text-[9.5px] uppercase tracking-[0.14em] text-[#303030]/50 mb-2">{col.lane}</p>
                        <div className="space-y-2">
                            {col.items.map((it, i) => (
                                <div
                                    key={it.t}
                                    className={`rounded-lg border px-2.5 py-2 pqx-pop-in ${
                                        it.active
                                            ? "border-[#FF4040]/40 bg-[#FF4040]/[0.05]"
                                            : "border-[#303030]/8 bg-white"
                                    }`}
                                    style={{ animationDelay: `${(ci * 2 + i) * 90}ms` }}
                                >
                                    <div className="flex items-center gap-1.5">
                                        {it.done && <Check className="w-3 h-3 text-[#FF4040]" />}
                                        {it.active && <span className="w-1.5 h-1.5 rounded-full bg-[#FF4040] pqx-anim-blink" />}
                                        <p className="text-[11px] font-medium text-[#303030] leading-tight">{it.t}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div className="px-4 py-2.5 border-t border-[#303030]/8 flex items-center justify-between bg-[#FAFAF8]">
                <span className="text-[11px] text-[#303030]/60">Senior-led pod · AI woven in</span>
                <span className="font-mono text-[10px] text-[#FF4040]">9 wks → GA</span>
            </div>
        </div>
    );
}
